var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\xB5\xD0\xB6\xD0\xB8\xD0\xBC_\xD0\xB8\xD0\xB7\xD0\xBE\xD0\xBB\xD1\x8F\xD1\x86\xD0\xB8\xD0\xB8",
    clipPath: "url(#clip0_8_93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8994 20.0554L21.7676 32.3437L9.64648 20.0554",
    stroke: "#FFFAF0",
    strokeWidth: 3.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7783 31.3259V1.96045",
    stroke: "#FFFAF0",
    strokeWidth: 3.65,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.075 32.333V42.0501H1.93555V32.333",
    stroke: "#FFFAF0",
    strokeWidth: 3.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.e8eae1dd6651ead9bb39456a228a284f.svg";
export { ForwardRef as ReactComponent };